import { motion } from "framer-motion";
import "../../asstes/styles/howEngagementOccurs.scss";

const steps = [
    {
        id: "01",
        title: "Private Alignment Review",
        desc: "A short written submission establishes gravity and readiness."
    },
    {
        id: "02",
        title: "Threshold Confirmation",
        desc: "Contribution is received in advance."
    },
    {
        id: "03",
        title: "Closed-Door Convening",
        desc: "One individual. One engagement. No fixed duration."
    },
    {
        id: "04",
        title: "Aftermath",
        desc: "No follow-up program. No advisory relationship. What remains belongs entirely to the individual."
    }
];

const HowEngagementOccurs = () => {
    return (
        <section className="how-engagement-v2">

            <div className="noise-layer"></div>

           
            <div className="container">

                {/* HEADING */}
                <motion.div
                    initial={{ opacity: 0, y: 80 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1 }}
                    viewport={{ once: true }}
                    className="heading-wrapper"
                >

                    <div className="section-tag">
                        <span></span>
                        THE PROCESS
                    </div>

                    <h2 className="main-title">
                        How <span>Engagement</span> Occurs
                    </h2>

                    <p className="title-description">
                        A confidential progression structured around
                        readiness, threshold, and direct engagement.
                    </p>

                </motion.div>

                {/* PROCESS GRID */}
                <div className="process-grid">

                    {steps.map((item, index) => (
                        <motion.div
                            key={index}
                            initial={{
                                opacity: 0,
                                y: 100,
                                scale: 0.8
                            }}
                            whileInView={{
                                opacity: 1,
                                y: 0,
                                scale: 1
                            }}
                            transition={{
                                duration: 0.8,
                                delay: index * 0.15
                            }}
                            viewport={{ once: true }}
                            whileHover={{
                                y: -12
                            }}
                            className="process-card"
                        >

                            {/* NUMBER */}
                            <div className="number-area">

                                <motion.div
                                    whileHover={{
                                        rotate: 360
                                    }}
                                    transition={{
                                        duration: 1
                                    }}
                                    className="number-circle"
                                >
                                    <span>{item.id}</span>
                                </motion.div>

                                <div className="number-line"></div>

                            </div>

                            {/* CONTENT */}
                            <div className="content-area">

                                <div className="card-top-glow"></div>

                                <h3>{item.title}</h3>

                                <p>{item.desc}</p>

                                <div className="card-hover-line"></div>

                            </div>

                        </motion.div>
                    ))}

                </div>

            </div>
        </section>
    );
};

export default HowEngagementOccurs;